<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap>
        <v-flex xs12>
            <v-btn
                    color="primary"
                    class="btn-new-organization"
                    @click="newOrganization"
            >
                New Organization
            </v-btn>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                class="elevation-1"
                :headers="headers"
                :items="organizations"
                :rows-per-page-items="rowsPerPageItems"
                :loading="organizationLoading"
            >
                <template v-slot:items="props">
                    <td>{{ props.item.displayName }}</td>
                    <td>{{ props.item.expiredAt }}</td>
                    <td>{{ orgStatus(props.item.expiredAt) }}</td>
                    <td>
                        <v-icon
                                small
                                @click="editOrganization(props.item)"
                                class="mr-2"
                        >edit
                        </v-icon>
                        <v-icon
                                small
                                @click="removeOrganization(props.item.uuid)"
                        >delete
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-flex>
        <v-dialog v-model="organizationDialog" width="500">
            <v-card>
                <v-card-title>
                    <h5 class="headline" primary-title>{{ dialogTitle }}</h5>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout column>
                            <v-flex>
                                <v-text-field
                                        label="Name"
                                        v-model="organization.name"
                                        data-vv-name="name"
                                        v-validate="'required'"
                                        :error-messages="errors.collect('name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex class="mt-2">
                                <v-menu
                                    v-model="orgExpirationMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="organization.expiredAt"
                                            label="Expiration Date"
                                            append-icon="event"
                                            readonly
                                            v-on="on"
                                            data-vv-name="expiredAt"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('expiredAt')"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="organization.expiredAt" 
                                        @input="orgExpirationMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="error"
                            flat
                            @click="organizationDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="primary"
                            flat
                            @click="save"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import { mapActions, mapState } from "vuex";
    import axios from 'axios';
    import moment from 'moment';
    import current_user from '../mixins/current_user';

    Vue.use(VeeValidate);

    const defaultExpirationDate = moment().add(1, 'years').format("YYYY-MM-DD");

    const defaultForm = {
        name: '',
        expiredAt: defaultExpirationDate,
    };

    export default {
        $_veeValidate: {
            validator: "new",
        },

        mixins: [current_user],

        data() {
            return {
                dictionary: {
                    custom: {
                        name: {
                            required: () => "Organization name is required.",
                        },
                        expiredAt: {
                            required: () => "Expiration Date is required.",
                        }
                    }
                },

                headers: [
                    {
                        text: 'Name',
                        value: 'name',
                        sortable: false
                    },
                    {
                        text: 'Expired At',
                        value: 'expiredAt',
                        sortable: false,
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        sortable: false,
                    },
                    {
                        text: 'Action',
                        value: 'externalId',
                        sortable: false
                    }
                ],

                rowsPerPageItems: [50],

                organization: {
                    name: '',
                    expiredAt: '',
                },

                organizationDialog: false,

                editOrganizationId: null,

                orgExpirationMenu: false,
            };
        },

        methods: {
            ...mapActions('organizations', ['fetchOrganizations', 'deleteOrganization']),

            save() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        if (this.isEditing) {
                            axios.put(process.env.VUE_APP_API_URL + 'organizations/' + this.editOrganizationId, this.organization)
                                .then(response => {
                                    if (response.data) {
                                        this.fetchOrganizations()
                                        this.organization.name = ''
                                        this.organizationDialog = false;
                                    }
                                });
                            this.$ua.trackEvent('UpdateOrg', 'click', 
                                `${this.currentUser.username || 'User'} updated ${this.editOrganizationId} with payload ${JSON.stringify(this.organization, null, 2)}`);
                        } else {
                            axios.post(process.env.VUE_APP_API_URL + 'organizations', this.organization)
                                .then(response => {
                                    if (response.data) {
                                        this.fetchOrganizations()
                                        this.organization.name = ''
                                        this.organizationDialog = false;
                                    }
                                });
                            this.$ua.trackEvent('CreateOrg', 'click', 
                                `${this.currentUser.username || 'User'} created ${JSON.stringify(this.organization, null, 2)}`);
                        }
                    }
                });
            },

            newOrganization() {
                this.organization = Object.assign({}, defaultForm);
                this.editOrganizationId = null;
                this.organizationDialog = true
            },
            
            editOrganization(organization) {
                this.editOrganizationId = organization.uuid
                this.organization = Object.assign({}, { name: organization.displayName, expiredAt: organization.expiredAt });
                this.organizationDialog = true
            },

            removeOrganization(orgID) {
                if (confirm('Are you sure to delete this organization?')) {
                    this.deleteOrganization(orgID).catch(({ response }) => alert(response.data.message));
                    this.$ua.trackEvent('DeleteOrg', 'click', 
                        `${this.currentUser.username || 'User'} deleted ${orgID}`);
                }
            },

            orgStatus(expiredAt) {
                return moment(expiredAt).format() >= moment().format() ? 'Active' : 'Expired';
            },
        },

        computed: {
            ...mapState('organizations', ['organizations', 'organizationLoading']),

            isValidOrganization() {
                return this.organization.name !== null
                    && this.organization.name.length > 0
            },

            dialogTitle() {
                return this.editOrganizationId ?
                    'Change organization name' : 'Add new organization'
            },

            isEditing() {
                return this.editOrganizationId !== null
            }
        },

        mounted() {
            this.$validator.localize("en", this.dictionary);
        },

        watch: {
            organizationDialog(value) {
                if (!value) {
                    setTimeout(() => {
                        Object.assign(this.organization, defaultForm);
                    }, 1000);
                }
                this.$validator.reset();
            }
        }
    }
</script>

<style scoped>
    .btn-new-organization {
        margin-left: 0;
        margin-right: 0;
    }
</style>
